module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner atvEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("新建商协会")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params1,
      "rules": _vm.rules,
      "inline-message": "true",
      "show-message": true
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("商协会名")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入商协会名称"
    },
    model: {
      value: (_vm.params1.title),
      callback: function($$v) {
        _vm.$set(_vm.params1, "title", $$v)
      },
      expression: "params1.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("入会条件")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('textEditor', {
    ref: "textEditor1",
    attrs: {
      "id": "textEditor1",
      "inContent": _vm.params2.membershipRequirements,
      "height": "300"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("提交材料")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('textEditor', {
    ref: "textEditor2",
    attrs: {
      "id": "textEditor2",
      "inContent": _vm.params2.submitMaterial,
      "height": "300"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("入会流程")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('textEditor', {
    ref: "textEditor3",
    attrs: {
      "id": "textEditor3",
      "inContent": _vm.params2.membershipProcess,
      "height": "300"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block tag-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标签")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('tag-select', {
    attrs: {
      "selectTags": _vm.params1.tagNames,
      "paramsKey": "tagNames"
    },
    on: {
      "selectChange": _vm.tagChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contactPerson"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params1.contactPerson),
      callback: function($$v) {
        _vm.$set(_vm.params1, "contactPerson", $$v)
      },
      expression: "params1.contactPerson"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("联系电话")])]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params1.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.params1, "contactPhone", $$v)
      },
      expression: "params1.contactPhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("申请网址")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "url"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params1.url),
      callback: function($$v) {
        _vm.$set(_vm.params1, "url", $$v)
      },
      expression: "params1.url"
    }
  })], 1)], 1)])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(3)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-c185cf38"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/message/assEdit.vue
// module id = 1558
// module chunks = 1